'use strict';

(function ($) {
  $(window).on('load', function () {

    if (!is_sp()) {
      line_height($('.points .case .lead'));
      line_height($('.points .case .point'));
    }

    /*
     * ハッシュ付きURLへ遷移時 スムーススクロール
     */
    delay(function () {
      var ua = navigator.userAgent;
      var scroll_tag = void 0;
      if (ua.indexOf('OPR') !== -1 || ua.indexOf('Edge') !== -1) {
        scroll_tag = 'body';
      } else {
        scroll_tag = !window.chrome && 'WebkitAppearance' in document.documentElement.style ? 'body' : 'html';
      }
      var hash = location.hash;
      if (hash) {
        var offset = $('header').outerHeight() + 20;
        var position = hash != '#' ? $(hash).offset().top - offset : 0;
        $(scroll_tag).animate({ scrollTop: position }, 500);
      }
    }, 200);
  });
})(jQuery);

(function ($) {
  $(document).ready(function () {

    /*
     * ページ内スムーススクロール
     */
    $('a[href^="#"]').on('click', function (event) {
      event.preventDefault();
      var ua = navigator.userAgent;
      var scroll_tag = void 0;
      if (ua.indexOf('OPR') !== -1 || ua.indexOf('Edge') !== -1) {
        scroll_tag = 'body';
      } else {
        scroll_tag = !window.chrome && 'WebkitAppearance' in document.documentElement.style ? 'body' : 'html';
      }
      var hash = $(this).attr('href');
      if (hash) {
        var offset = $('header').outerHeight() + 20;
        var position = hash != '#' ? $(hash).offset().top - offset : 0;
        $(scroll_tag).animate({ scrollTop: position }, 500);
        $('.sp_menu span, .sp_nav').removeClass('active');
      }
    });

    $('.sp_menu').on('click', function (event) {
      event.preventDefault();
      $(this).find('span').toggleClass('active');
      $(this).siblings('.sp_nav').toggleClass('active');
    });

    $('.qa .items li .head').on('click', function () {
      $(this).find('.sw .icon').toggleClass('active');
      $(this).siblings('.body').slideToggle(200);
    });

    $('.disposal_limit .days .num').each(function () {
      var DateTime = luxon.DateTime;
      var Interval = luxon.Interval;
      var now = DateTime.local();
      var limit = DateTime.fromISO($(this).data('limit'));
      var diff = Math.floor(Interval.fromDateTimes(now, limit).length('days'));
      diff = Number.isNaN(diff) ? 0 : diff;
      diff = zerofill(diff, 4);
      $(this).text(diff);
    });
  });
})(jQuery);

/*
 * SP/PC判別
 */
var is_sp = function is_sp() {
  if (window.innerWidth <= 1000) {
    return true;
  } else {
    return false;
  }
};

/*
 * 高さを揃える
 */
var line_height = function line_height(el) {
  var min_h = 0;
  el.each(function () {
    var h = $(this).outerHeight();
    if (h > min_h) {
      min_h = h;
    }
  });
  el.outerHeight(min_h);
};

/*
 * ゼロフィル
 */
var zerofill = function zerofill(number, length) {
  return (Array(length).join('0') + number).slice(-length);
};

/*
 * 関数の遅延実行
 */
var delay = function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
}();